import { css } from '@emotion/react';
import { classNames } from '@frontend/string';

export type VerticalGridProps = React.PropsWithChildren<
  {
    className?: string;
  } & React.HTMLAttributes<HTMLDivElement>
>;

const styles = css`
  display: grid;
  gap: 1rem;
  grid-template-columns: minmax(0px, 1fr);
`;
export const VerticalGrid = ({ children, className, ...rest }: VerticalGridProps) => {
  return (
    <div className={classNames('payment-methods__vertical-grid', className)} css={styles} {...rest}>
      {children}
    </div>
  );
};
